<template>
  <v-container>
    <v-row justify="center" alignment="center">
      <v-col cols="12" md="8" class="text-center">
        <h1>Hard Fail</h1>
        <h3>Sorry. Your uploaded receipt is invalid.</h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Sorry',
  components: {
  },
  data: () => ({
    
  }),
};
</script>
